<script setup lang="ts">
import HomeView from './[lcid]/index.vue'
</script>

<template>
  <HomeView />
</template>
